export default "__VITE_ASSET__D0_68H4n__"